import React, { useState, Suspense } from "react";
import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  ListItemProps,
  Button,
  CircularProgress,
  Link,
} from "@material-ui/core";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import EmailIcon from "@material-ui/icons/Email";
import { useStyles } from "../styles/ContactUs";
import { Helmet } from "react-helmet";

const FormSubmitMsg = React.lazy(() => import("../components/FormSubmitMsg"));

const contactData = {
  location: "Manchester, UK",
  locationLink:
    "https://www.google.com/maps/place/Manchester/@53.4723272,-2.2935024,12z/data=!3m1!4b1!4m5!3m4!1s0x487a4d4c5226f5db:0xd9be143804fe6baa!8m2!3d53.4807593!4d-2.2426305",
  email: "digitalyethumane@manchester.ac.uk",
};

function ListItemLink(props: ListItemProps<"a", { button?: true }>) {
  return <ListItem button component="a" {...props} />;
}

export default function ContactUs() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const classes = useStyles();

  return (
    <div style={{ maxWidth: "100%" }}>
      <Helmet>
        <title>Contact Us</title>
        <meta
          name="Constact Us Page"
          content="contact us form and information"
        />
      </Helmet>

      {submitted ? (
        <Suspense fallback={<CircularProgress />}>
          <FormSubmitMsg setSubmitted={setSubmitted} isFeedback={false} />
        </Suspense>
      ) : (
        <Grid container spacing={3} className={classes.root}>
          <>
            <Grid item xs={12} sm={12} className={classes.intro}>
              <Typography className={classes.title} variant="h2">
                Contact Us
              </Typography>
              <div className={classes.icons}>
                <Link
                  underline="none"
                  href={`${contactData.locationLink}`}
                  target="_blank"
                >
                  <LocationOnIcon
                    style={{ color: "white", marginRight: "3em" }}
                  />
                </Link>
                <a
                  href="mailto:digitalyethumane@manchester.ac.uk"
                  target="_blank"
                  rel="noreferrer"
                >
                  <EmailIcon style={{ color: "white" }} />
                </a>
              </div>
            </Grid>
            <div className={classes.contactRoot}>
              <Grid item xs={12} sm={12} className={classes.form}>
                <form
                  action="https://formsubmit.co/538ae396429fc08abe9c1dc4468bf8c4"
                  method="POST"
                >
                  <input
                    type="hidden"
                    name="_subject"
                    value="Contact Us Message"
                  />
                  <input
                    type="hidden"
                    name="_next"
                    value="https://humanizing-online-services-toolkit.netlify.app/"
                  />
                  <div className={classes.formArea}>
                    <input
                      type="text"
                      name="name"
                      placeholder="Full Name"
                      required
                      className={classes.inputBox}
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                    />
                    <input
                      type="email"
                      name="email"
                      placeholder="Your Email (if you want a reply)"
                      className={classes.inputBox}
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                    />
                  <textarea
                    placeholder="Your Message"
                    name="message"
                    required
                    className={classes.msgBox}
                    onChange={(e) => setMessage(e.target.value)}
                    value={message}
                  />
                  <Button type="submit" className={classes.btn}>
                    Send Message
                  </Button>
                  </div>
                </form>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.details}>
                  <List component="nav" className={classes.navRoot}>
                    <ListItem button>
                      <ListItemLink
                        href={contactData.locationLink}
                        target="_blank"
                      >
                        <ListItemIcon>
                          <LocationOnIcon style={{ color: "white" }} />
                        </ListItemIcon>
                        <ListItemText primary={contactData.location} />
                      </ListItemLink>
                    </ListItem>
                    <ListItem button>
                      <ListItemLink
                        href="mailto:digitalyethumane@manchester.ac.uk"
                        target="_blank"
                      >
                        <ListItemIcon>
                          <EmailIcon style={{ color: "white" }} />
                        </ListItemIcon>
                        <ListItemText primary={contactData.email} />
                      </ListItemLink>
                    </ListItem>
                  </List>
                </div>
              </Grid>
            </div>
          </>
        </Grid>
      )}
    </div>
  );
}
